module.exports = __webpack_public_path__ + "img/coworking-animate.fc39904e.svg";